<template>
    <SideHeader :to="'/newCargos'" :cargo="cargo" :isCargo="true" />
    <div style="padding-top: 5.5rem;">
        <div id="loader" v-if="loading">
            <div class="spinner-border text-primary" role="status"></div>
        </div>
        <div v-else>
            <div class="bg-white">
                <div class="text-center mb-2">
                    <img class="img-fluid" width="150" src="assets/img/F2.png" alt="">
                </div>
                <div class="m-2">
                    <!-- <div class="chip chip-media my-2">
                        <ion-icon name="calendar-outline"></ion-icon>
                        <span class="chip-label">{{ cargo.loadingDate }}</span>
                    </div> -->
                    <div class="card-body py-0">
                        <WithoutPrice :distanceCity="this.cargo.distanceCity" :distanct="this.cargo.distanct"
                            :fromCity="this.cargo.fromCity" :toCity="this.cargo.toCity" />
                    </div>
                    <!-- <PaymentBox :cargo="cargo" /> -->
                    <div class="return-loads-wrapper">

                        <!-- <div class="return-loads-text">
                            <button type="button" class="btn btn-link load-back p-0" data-bs-toggle="offcanvas"
                                @click="getDetailLoad" :data-bs-target="'#cargoDetail' + loadId">
                                مشاهده جزئیات بار
                                <ion-icon role="img" class="md hydrated" style="font-size: 15px;"
                                    name="chevron-forward-outline"></ion-icon>
                            </button>
                        </div> -->

                        <!-- <div class="return-loads-text">
                            <p>
                                <router-link class="btn btn-link load-back p-0"
                                    :to="{ name: 'returnLoads', params: { city: cargo.destination_city_id } }">
                                    مشاهده بارهای مقصد
                                    <ion-icon role="img" class="md hydrated" name="chevron-forward-outline"
                                        style="font-size:15px; padding-top: 2px;"></ion-icon>
                                </router-link>
                            </p>


                        </div> -->
                    </div>
                    <div class="section full mt-1 pb-7">
                        <ul class="nav nav-tabs lined border-gray" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" data-bs-toggle="tab" :href="'#cargo' + loadId" role="tab">
                                    اطلاعات بار
                                </a>
                            </li>
                            <!-- <li class="nav-item" v-show="owner != null && owner?.isAccepted == 1">
                                <a class="nav-link" data-bs-toggle="tab" :href="'#owner' + loadId" role="tab">
                                    صاحب بار
                                </a>
                            </li> -->
                        </ul>

                        <div class="tab-content mt-2">
                            <div class="tab-pane fade show active" :id="'cargo' + loadId" role="tabpanel">
                                <LoadInfo :loading="loading" :cargo="cargo" :owner="owner" />

                                <AlertDriver :owner="owner" :loadId="loadId" />
                            </div>
                            <div class="tab-pane fade" :id="'owner' + loadId" role="tabpanel">
                                <div class="text-center mb-2">
                                    <div class="avatar">
                                        <img src="assets/img/sample/avatar/Untitled-1.png" alt="avatar"
                                            class="imaged w64 rounded" />
                                    </div>
                                    <!-- <p class="fw-bolder my-1">{{ owner?.name + ' ' + owner?.lastName }}</p> -->
                                    <div class="my-1" style="display:inline-block;"
                                        v-if="owner?.ratingOwner != null && owner?.isAccepted == 1">
                                        <star-rating :inline="true" :star-size="16" :read-only="true"
                                            :show-rating="false" :rating="owner.ratingOwner"></star-rating>
                                    </div>
                                    <div v-if="owner?.ratingOwner == null && owner?.isAccepted == 1" class="my-1">
                                        <star-rating :inline="true" :star-size="16" :read-only="true"
                                            :show-rating="false" :rating="5"></star-rating>
                                    </div>
                                    <p class="text-TEAL owner-title" v-if="owner?.isAccepted == 1">تایید شده</p>
                                    <hr class="m-0" />
                                    <!-- <div class="text-left">
                                        <div class="return-loads-text">
                                            <button type="button" class="btn btn-link load-back p-0"
                                                data-bs-toggle="offcanvas" @click="getDetailLoad"
                                                :data-bs-target="'#cargoDetail' + loadId">
                                                مشاهده جزئیات بار
                                                <ion-icon role="img" class="md hydrated"
                                                    style="font-size: 15px; padding-top: 6px;"
                                                    name="chevron-forward-outline"></ion-icon>
                                            </button>
                                        </div>
                                    </div> -->

                                    <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1"
                                        :id="'cargoDetail' + loadId">
                                        <div class="offcanvas-header">
                                            <h5 class="offcanvas-title">جزئیات بیشتر</h5>
                                        </div>
                                        <div class="offcanvas-body">
                                            <Optional :loadId="loadId" :optional="optional" :cargo="cargo" />
                                        </div>
                                    </div>


                                </div>
                                <AlertDriver :owner="owner" :loadId="loadId" />

                            </div>

                        </div>
                    </div>

                </div>

                <!-- * Default Action Sheet Inset -->
                <div class="footer-position px-3" id="footer">
                    <div class="row my-2 g-1">
                        <div class="col">

                            <button v-if="loadingCall == 0" type="button" @click.prevent="callToOwner"
                                class="btn background-blue btn-block text-light btn-block" style="height: 3rem">
                                <ion-icon name="call-outline" role="img" class="md hydrated"
                                    aria-label="logo dropbox"></ion-icon>
                                تماس با صاحب بار
                            </button>

                            <button v-else class="btn background-blue text-light btn-block" type="button" disabled="">
                                <span class="spinner-border spinner-border-sm me-05" role="status"
                                    aria-hidden="true"></span>
                                درحال بارگذاری ...
                            </button>

                            <button style="display: none" :id="'pardakht_' + loadId" type="button"
                                class="btn background-blue text-light btn-block" @click="offPardakht"
                                data-bs-toggle="offcanvas" :data-bs-target="'#actionSheetContent_' + loadId">
                                <ion-icon name="call-outline" role="img" class="md hydrated"
                                    aria-label="logo dropbox"></ion-icon>
                                پرداخت
                            </button>

                            <Peyment :driver_id="idUser" :data="loadId" />
                        </div>
                    </div>
                    <!-- <div class="row g-1">
                        <div class="col" v-if="cargo.userType == 'owner' && statusAcceptCargo == 0 && accept == 0">

                            <button class="btn btn-acceptCargo btn-block" type="button" :disabled="loadAccept == 1"
                                @click.prevent="submitCargo()">
                                <span v-if="loadAccept == 1" class="spinner-border spinner-border-sm me-05"
                                    role="status" aria-hidden="true"></span>
                                <ion-icon v-else name="checkmark-outline" role="img" class="md hydrated"
                                    aria-label="logo dropbox"></ion-icon>
                                {{ loadAccept == 1 ? 'درحال بارگذاری ...' : 'پذیرش حمل بار' }}
                            </button>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import delivery_methods from "@/delivery_methods";
import WithoutPrice from "@/components/fromToCity/WithoutPrice.vue";
// import Placeholder from "@/components/Placeholder.vue";
// import PaymentBox from "@/components/PaymentBox.vue";
import LoadInfo from "./components/LoadInfo.vue";
import AlertDriver from "@/components/AlertDriver.vue";
import StarRating from 'vue-star-rating'
import Swal from "sweetalert2";
import SideHeader from "@/components/SideHeader.vue";
// import Routing from "./components/Routing.vue";
import Peyment from "@/components/Peyment.vue";
export default {
    components: {
        // Placeholder,
        WithoutPrice,
        // PaymentBox,
        LoadInfo,
        // PlaceholderLine,
        // Optional,
        AlertDriver,
        StarRating,
        SideHeader,
        // Routing,
        Peyment
    },
    data() {
        return {
            loadId: this.$route.params.load,
            idUser: window.localStorage.getItem("idUser"),
            cargo: '',
            owner: '',
            loading: false,
            optional: [],
            path: '',
            loadAccept: 0,
            accept: 0,
            statusAcceptCargo: 0,
            loadingCall: 0,
            weatherTo: '',
            axiosConfig: {
                headers: {
                    'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
                    'Accept': 'application/json'
                }
            }
        };
    },
    methods: {
        getDetailLoad() {
            localStorage.setItem("openDetailLoad", this.loadId);
            if (history.pushState) {
                var newurl = window.location.protocol +
                    "//" +
                    window.location.host +
                    window.location.pathname +
                    "?openDetailLoad=1";
                window.history.pushState({ path: newurl }, "", newurl);
            }
        },
        getDetail() {
            this.loading = true;
            axios.get(`${delivery_methods.BASE_URL}api/driver/loadDetail/${this.loadId}}`, this.axiosConfig)
                .then((res) => {
                    this.statusAcceptCargo = res.data.result;
                    this.loading = false;
                    this.cargo = res.data.loadInfo;
                    // this.weathers();
                    console.log(res.data);
                    this.owner = res.data.owner;
                    this.path = res.data.path;
                    if (res.data.location_date == false) {
                        this.getLocation();
                    }
                });
        },
        offClose() {
            localStorage.setItem("offClose", this.loadId);
            if (history.pushState) {
                var newurl = window.location.protocol +
                    "//" +
                    window.location.host +
                    window.location.pathname +
                    "?offClose=1";
                window.history.pushState({ path: newurl }, "", newurl);
            }
        },
        callToOwner() {
            this.loadingCall = 1;
            axios.get(`${delivery_methods.BASE_URL}api/driver/checkDriverStatusForCalling/${this.cargo.mobileNumberForCoordination}/${this.loadId}/${window.localStorage.getItem("latitude")}/${window.localStorage.getItem("longitude")}`, this.axiosConfig)
                .then((res) => {
                    console.log(res.data);
                    if (res.data.result == 1 || res.data.result == true) {
                        // Directly call the number
                        window.location.href = 'tel:' + this.cargo.mobileNumberForCoordination;
                        // document.getElementById('reportCall').show();
                    }

                    else if (res.data.result == false) {
                        document.getElementById("pardakht_" + this.loadId).click();
                    }
                    else if (res.data.result == 2) {
                        Swal.fire({
                            position: "center",
                            icon: "warning",
                            title: "آگهی منقضی شده است",
                            showConfirmButton: false,
                            timer: 2000,
                        });
                    }
                    // callStatus.value = response.data;
                })
                .catch(function (error) {
                    setTimeout(() => {
                        this.loading = 0;
                    }, 5000);
                    // handle error
                    console.log(error);
                }).finally(() => {
                    this.loadingCall = 0
                });
        },
        submitCargo() {
            this.loadAccept = 1;
            axios.post("https://xpanel.s-bar.ir/api/driver/storeInquiryToLoad", {
                load_id: this.loadId,
                price: this.cargo.suggestedPrice == null ? 0 : this.cargo.suggestedPrice,
                latitude: window.localStorage.getItem("latitude"),
                longitude: window.localStorage.getItem("longitude")
                // city: window.localStorage.getItem("city"),
            }, this.axiosConfig)
                .then((res) => {
                    if (res.data.result == 1) {
                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: "درخواست شما با موفقیت ثبت شد",
                            showConfirmButton: false,
                            timer: 2000,
                        });
                    }
                    else {
                        Swal.fire({
                            position: "top-end",
                            icon: "error",
                            title: "شما به محدودیت تماس رسیده اید",
                            showConfirmButton: false,
                            timer: 2000,
                        });
                        document.getElementById("pardakht").click();
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
                .finally((res) => {
                    this.loadAccept = 0;
                    this.accept = 1;
                });
        },
        offPardakht() {
            localStorage.setItem("offPardakht", this.loadId);
            if (history.pushState) {
                var newurl = window.location.protocol +
                    "//" +
                    window.location.host +
                    window.location.pathname + "?offPardakht=1";
                window.history.pushState({ path: newurl }, "", newurl);
            }
        },
        getLocation() {
            // this.loading = true;
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    this.showPosition,
                    this.showError
                );
            }
        },
        showPosition(position) {
            axios.get(
                `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=` + position.coords.latitude + `&longitude=` + position.coords.longitude + `&localityLanguage=fa`)
                .then((response) => {
                    axios.put(`https://xpanel.s-bar.ir/api/driver/updateLocation`, {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        city: response.data.city,
                    }, this.axiosConfig).then((res) => {
                        // console.log(res);
                    }).catch(() => {
                        //
                    });
                });
        },
        weathers() {
            axios.get(`https://api.openweathermap.org/data/2.5/weather?lat=44.34&lon=10.99&appid=5f03d362072b012cff654e5b1a98e6b0`)
                .then((response) => {
                    console.log(response);
                }).catch(() => {
                    this.weathers();
                });
        },
    },
    created() {
        this.getDetail();
    }
};
</script>

<style scoped>
.leaflet-container {
    z-index: 0 !important;
}

.appBottomMenu {
    display: none !important;
}

.weather-to {
    position: absolute;
    top: 3.8rem;
    background-color: #FFFFFFCC !important;
    border-radius: 6px;
    padding: 5px;
    margin: 0 3px;
}

.routing {
    position: absolute;
    top: 140px;
    left: 1rem;
    /* z-index: 999; */
}

.background-locate {
    background-color: #FFFFFFCC !important;
}

.text-locate {
    color: #0099c9 !important;
}

.owner-title {
    margin-top: 10px;
    font-weight: 700;
}


.return-loads-wrapper {
    align-self: center;
    display: flex;
    font-size: 13px;
    padding: 4px 4px;
    float: left;
}


.return-loads-icon {
    /* aspect-ratio: 1; */
    object-fit: auto;
    object-position: center;
    width: 16px;
    margin: auto 0;
}

.return-loads-text {
    font-family: IRANSansXFaNum, sans-serif;
}

.space_detail {
    border-bottom: 1px dashed #e6e6e6;
    padding-bottom: 5px;
}

.footer-position {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    padding: 10px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    /* z-index: 1000; */
}

.bg-white {
    padding-bottom: 80px; /* ارتفاع footer + حاشیه */
}

.load-back {
    /* float: left; */
    color: var(--Primery, #0099c9);
    font-weight: 400
}

.border-gray {
    border-bottom: 1px solid #d9d9d9;
}

.btn-acceptCargo {
    color: #0099c9 !important;
    background: #fff;
    border: 1px solid;
}
</style>